import { type BadgeType } from '@/features/shared/elements/Badges/types'

type ProductTextBadgeProduct = {
  purchaseLimit?: number
  lowStock?: boolean
  for_you?: boolean
  bought?: boolean
  oos?: boolean
}

const MAX_PURCHASE_LIMIT = 5

export const getProductTextBadge = (
  product: ProductTextBadgeProduct,
  options?: {
    isEbtEligible?: boolean
  },
) => {
  const { purchaseLimit = 0, lowStock = false, for_you = false, bought = false, oos } = product

  const { isEbtEligible = false } = options || {}

  const productTextBadges: BadgeType[] = []

  if (oos) {
    productTextBadges.push('oos')
  }

  if (bought) {
    productTextBadges.push('buyAgain')
  }

  if (isEbtEligible) {
    productTextBadges.push('snapEbtEligible')
  }

  if (lowStock && !product.oos) {
    productTextBadges.push('lowStock')
  }

  const showPurchaseLimit = Boolean(purchaseLimit) && purchaseLimit < MAX_PURCHASE_LIMIT

  if (showPurchaseLimit) {
    productTextBadges.push('limit')
  }

  if (for_you) {
    productTextBadges.push('forYou')
  }

  return {
    showPurchaseLimit,
    showProductTextBadge: productTextBadges.length !== 0,
    productTextBadges,
    purchaseLimit,
  }
}
